import { ReactNode } from 'react';
import { useAsyncFn } from 'react-use';

import { ChatSuggestion } from '@/modules/common/Chat/components/ChatSuggestion';

import { useHouseholdChatContext } from '../contexts/householdChat.context';

export interface HouseholdChatSuggestionProps {
  question: string;
  /** Optional leading icon, chosen by the question's type. */
  icon?: ReactNode;
}

export function HouseholdChatSuggestion({
  question,
  icon,
}: HouseholdChatSuggestionProps) {
  const { sendMessage } = useHouseholdChatContext();

  // sendMessage owns reporting and recovery for every send entry point.
  const [{ loading }, handleClick] = useAsyncFn(
    () => sendMessage(question),
    [question, sendMessage]
  );

  return (
    <ChatSuggestion
      question={question}
      onClick={handleClick}
      loading={loading}
      icon={icon}
    />
  );
}
